<template>
    <div>
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">Решения</h1><Breadcrumbs title="Решения"/></div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row row-grid">
                    <div class="col-lg-4 mt-4 pr-2 pl-2" v-for="item in solutions" :key="item.ID">
                        <card class="border-0 p-0" shadow body-classes="p-0">
                            <img :src="$root.baseURL + item.PREVIEW_PICTURE" width="100%">
                            <div class="p-4">
                                <h6 class="text-default text-uppercase text-center" style="height:80px">{{item.NAME}}</h6>
                                <div class="d-flex align-items-end justify-content-end" style="height: 10px">

                                    <a v-if="item.ID == 169" href="http://www.megratec.ru/product_categories/6/products/73" target="_blank" :title="item.NAME">
                                        <span class="text-default mr-2">Обзор</span>
                                        <base-button class="ml-1 btn-sm btn-default"
                                                     icon="fa fa-chevron-right">
                                        </base-button>
                                    </a>
                                    <a v-else-if="item.ID == 168" href="http://www.megratec.ru/product_categories/5" target="_blank" :title="item.NAME">
                                        <span class="text-default mr-2">Обзор</span>
                                        <base-button class="ml-1 btn-sm btn-default"
                                                     icon="fa fa-chevron-right">
                                        </base-button>
                                    </a>
                                    <router-link v-else-if="item.CODE" :to="'/solution/' + item.CODE" :title="item.NAME">
                                        <span class="text-default mr-2">Обзор</span>
                                        <base-button class="ml-1 btn-sm btn-default"
                                                     icon="fa fa-chevron-right">
                                        </base-button>
                                    </router-link>
                                    <router-link v-else :to="'/solution/' + item.ID" :title="item.NAME">
                                        <span class="text-default mr-2">Обзор</span>
                                        <base-button class="ml-1 btn-sm btn-default"
                                                     icon="fa fa-chevron-right">
                                        </base-button>
                                    </router-link>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <ContactForm></ContactForm>
    </div>
</template>
<script>
    import ContactForm from "@/components/ContactForm.vue";
    export default {
        components: {
            ContactForm,
        },
        data() {
            return {
                solutions: []
            };
        },
        mounted() {
            this.loadInfo()
        },
        methods: {
            async loadInfo() {
                let params = new Map();
                params.set('entity', 'solutions');

                this.solutions = await this.$root.loadContent(params)

                let params_2 = new Map();
                params_2.set('entity', 'pages');
                params_2.set('code', 'solutions');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            }
        }
    };
</script>
<style>
</style>